/* Renders a video or image based on the file URL extension.
   Used so admin-uploaded ads/imagery can be EITHER a still image OR a short looping video. */

const VIDEO_EXT = /\.(mp4|webm|mov|m4v|ogv)(\?|#|$)/i;

export function isVideoUrl(url) {
  return typeof url === "string" && VIDEO_EXT.test(url);
}

export default function Media({ src, alt = "", className = "", videoProps = {}, ...rest }) {
  if (!src) return null;
  if (isVideoUrl(src)) {
    return (
      <video
        src={src}
        className={className}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        aria-label={alt}
        {...videoProps}
        {...rest}
      />
    );
  }
  return <img src={src} alt={alt} className={className} loading="lazy" {...rest} />;
}
